import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const SELECTION_TIMEOUT_MS = 15000;
const selectionRead = (path, options = {}) => client.get(path, { timeout: SELECTION_TIMEOUT_MS, ...options }).then((r) => r.data);

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("td_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const publicApi = {
  categories: () => client.get("/categories").then((r) => r.data),
  articles: (params) => client.get("/articles", { params }).then((r) => r.data),
  trending: () => client.get("/articles/trending").then((r) => r.data),
  article: (slug) => client.get(`/articles/${slug}`).then((r) => r.data),
  homepageSidebar: () => client.get("/homepage-sidebar").then((r) => r.data),
  quickBites: () => client.get("/quick-bites").then((r) => r.data),
  dailyDish: () => client.get("/daily-dish").then((r) => r.data),
  search: (params) => client.get("/search", { params }).then((r) => r.data),
  subscribe: (email) => client.post("/newsletter/subscribe", { email }).then((r) => r.data),
};

export const authApi = {
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
};

export const adminApi = {
  translationReliability: () => selectionRead('/admin/newsroom/translation-reliability'),
  discovery: () => selectionRead('/admin/discovery'),
  refreshDiscovery: () => client.post('/admin/discovery/refresh').then((r) => r.data),
  dashboard: () => client.get("/admin/dashboard").then((r) => r.data),
  newsroomStatus: () => client.get("/admin/newsroom/automation/status").then((r) => r.data),
  usage: () => client.get("/admin/newsroom/usage").then((r) => r.data),
  queue: (params, signal) => selectionRead("/admin/queue", { params, signal }),
  reviewQueue: () => client.get("/admin/newsroom/review-queue", { params: { limit: 100 } }).then((r) => r.data),
  reviewDetail: (storyId) => client.get(`/admin/newsroom/review-queue/${encodeURIComponent(storyId)}`).then((r) => r.data),
  decideReview: (storyId, action, note) => client.post(`/admin/newsroom/stories/${encodeURIComponent(storyId)}/${action}`, { note, confirmed: true }).then((r) => r.data),
  promote: (id, action) => client.post(`/admin/queue/${encodeURIComponent(id)}/promote`, action).then(r => r.data),
  reevaluate: (id, action) => client.post(`/admin/newsroom/stories/${encodeURIComponent(id)}/reevaluate`, action).then(r => r.data),
  workflow: (id) => selectionRead(`/admin/workflows/${encodeURIComponent(id)}`),
  story: (id) => client.get(`/admin/queue/${id}`).then((r) => r.data),
  updateStatus: (id, status, note) => client.patch(`/admin/queue/${id}`, { status, note }).then((r) => r.data),
  sources: () => client.get("/admin/sources").then((r) => r.data),
  toggleSource: (id) => client.patch(`/admin/sources/${encodeURIComponent(id)}/toggle`).then((r) => r.data),
  addSource: (data) => client.post('/admin/sources', data).then((r) => r.data),
  editSource: (id, data) => client.put(`/admin/sources/${encodeURIComponent(id)}`, data).then((r) => r.data),
  testSource: (feed_url) => client.post('/admin/sources/test', { feed_url }, { timeout: 30000 }).then((r) => r.data),
  deleteSource: (id) => client.delete(`/admin/sources/${encodeURIComponent(id)}`, { data: { confirmed: true } }).then((r) => r.data),
  runIngestion: () => client.post("/admin/ingestion/run").then((r) => r.data),
  ingestionStatus: () => client.get("/admin/ingestion/status").then((r) => r.data),
  processFreshStories: () => client.post("/admin/scout/process").then((r) => r.data),
  previewFreshStories: () => client.post("/admin/scout/process?dry_run=true").then((r) => r.data),
  scoutStatus: () => client.get("/admin/scout/status").then((r) => r.data),
  evaluateTrends: () => client.post("/admin/trends/evaluate?dry_run=true").then((r) => r.data),
  trendStatus: () => client.get("/admin/trends/status").then((r) => r.data),
  evaluateEditor: (params = {}) => client.post("/admin/editor/evaluate", null, { params: { dry_run: true, ...params } }).then((r) => r.data),
  editorStatus: () => client.get("/admin/editor/status").then((r) => r.data),
  videos: () => client.get("/admin/videos").then((r) => r.data),
};

export default client;

